<template>
  <div>
    <!-- 新增/编辑的对话框 -->
    <el-dialog 
      class="edit-dialog" 
      :title="title" 
      :visible.sync="dialogVisible" 
      width="60%" 
      :modal-append-to-body="true"
      append-to-body 
      close-on-click-modal 
      @closed="handleClose">
      
      <el-form 
        ref="form" 
        :model="form" 
        :rules="rules" 
        label-width="120px" 
        label-position="right">
        
        <!-- 基本信息 -->
        <el-form-item label="名称" prop="name">
          <el-input 
            v-model="form.name" 
            placeholder="请输入名称" 
            maxlength="100" 
            show-word-limit>
          </el-input>
        </el-form-item>
        
        <el-form-item label="应用包名" prop="packageName">
          <el-input 
            v-model="form.packageName" 
            placeholder="请输入应用包名（可选）" 
            maxlength="99" 
            show-word-limit>
          </el-input>
        </el-form-item>
        
        <el-form-item label="打开方式" prop="openMode" required>
          <el-select v-model="form.openMode" placeholder="请选择打开方式" style="width: 100%">
            <el-option label="应用首页" :value="1"></el-option>
            <el-option label="Activity 方式" :value="2"></el-option>
            <el-option label="Action 方式" :value="3"></el-option>
            <el-option label="URLScheme 方式" :value="4"></el-option>
            <el-option label="Broadcast 方式" :value="5"></el-option>
            <el-option label="Service 服务方式" :value="6"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="打开地址" prop="openUrl" required>
          <el-input 
            v-model="form.openUrl" 
            placeholder="请输入打开地址" 
            maxlength="999" 
            show-word-limit>
          </el-input>
        </el-form-item>
        
        <!-- 打开参数 -->
        <el-form-item label="打开参数">
          <div class="params-container">
            <el-button type="primary" size="small" @click="addParam">添加参数</el-button>
            <div v-if="form.openParam.length > 0" class="params-list">
              <div 
                v-for="(param, index) in form.openParam" 
                :key="index" 
                class="param-item">
                <el-input 
                  v-model="param.key" 
                  placeholder="参数名" 
                  style="width: 200px; margin-right: 10px">
                </el-input>
                <el-input 
                  v-model="param.value" 
                  placeholder="参数值" 
                  style="width: 200px; margin-right: 10px">
                </el-input>
                <el-button 
                  type="danger" 
                  size="small" 
                  @click="removeParam(index)">
                  删除
                </el-button>
              </div>
            </div>
          </div>
        </el-form-item>
        
        <!-- 应用其他信息 -->
        <el-divider content-position="left">应用其他信息</el-divider>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="应用ID">
              <el-input 
                v-model="form.appId" 
                placeholder="请输入应用ID（可选）">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应用名称">
              <el-input 
                v-model="form.appName" 
                placeholder="请输入应用名称（可选）">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Appkey">
              <el-input 
                v-model="form.appKey" 
                placeholder="请输入Appkey（可选）">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应用版本号">
              <el-input 
                v-model="form.appVer" 
                placeholder="请输入应用版本号（可选）">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item label="备注">
          <el-input 
            v-model="form.remark" 
            type="textarea" 
            :rows="3" 
            placeholder="请输入备注（可选）">
          </el-input>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addAppJump, getAppJumpDetail, updateAppJump } from "@/api/apps/appJumpManage";
import Message from "@/components/Message";

export default {
  name: "AppJumpManageEdit",
  data() {
    return {
      /** 对话框是否可见 */
      dialogVisible: false,
      /** 操作类型：add-新增，edit-编辑，copy-复制 */
      operationType: "add",
      /** 编辑的数据ID */
      editId: null,
      /** 提交加载状态 */
      submitLoading: false,
      /** 表单数据 */
      form: {
        name: "",
        packageName: "",
        openMode: "",
        openUrl: "",
        openParam: [],
        appId: "",
        appName: "",
        appKey: "",
        appVer: "",
        remark: ""
      },
      /** 表单验证规则 */
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" }
        ],
        openMode: [
          { required: true, message: "请选择打开方式", trigger: "change" }
        ],
        openUrl: [
          { required: true, message: "请输入打开地址", trigger: "blur" }
        ]
      }
    };
  },

  computed: {
    /** 弹窗标题 */
    title() {
      const titles = {
        add: "新增应用跳转",
        edit: "编辑应用跳转",
        copy: "复制应用跳转"
      };
      return titles[this.operationType] || "应用跳转";
    }
  },

  methods: {
    /** 将后端openParam(字符串/对象/数组)统一转换为数组[{key,value}] */
    normalizeOpenParamToArray(val) {
      try {
        let obj = val;
        if (!val) return [];
        if (typeof val === 'string') {
          obj = JSON.parse(val);
        }
        if (Array.isArray(obj)) {
          // 兼容已是数组的情况
          return obj.map(item => ({ key: item.key || '', value: item.value || '' }));
        }
        if (typeof obj === 'object') {
          return Object.entries(obj).map(([key, value]) => ({ key, value }));
        }
        return [];
      } catch (e) {
        return [];
      }
    },

    /** 显示弹窗 */
    show(type, data = null) {
      this.operationType = type;
      this.dialogVisible = true;
      
      if (type === 'edit' && data && data.id) {
        this.editId = data.id;
        this.getDetail(data.id);
      } else if (type === 'copy' && data) {
        this.form = { ...data };
        // 复制时规范化参数
        this.form.openParam = this.normalizeOpenParamToArray(this.form.openParam);
        this.form.id = null;
      } else {
        this.resetForm();
      }
    },
    
    /** 获取详情 */
    async getDetail(id) {
      try {
        const { data } = await getAppJumpDetail(id);
        this.form = data.data;
        // 将openParam规范化为数组
        this.form.openParam = this.normalizeOpenParamToArray(this.form.openParam);
      } catch (error) {
        Message.error("获取详情失败");
      }
    },
    
    /** 重置表单 */
    resetForm() {
      this.form = {
        name: "",
        packageName: "",
        openMode: "",
        openUrl: "",
        openParam: [],
        appId: "",
        appName: "",
        appKey: "",
        appVer: "",
        remark: ""
      };
      this.editId = null;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    
    /** 添加参数 */
    addParam() {
      this.form.openParam.push({
        key: "",
        value: ""
      });
    },
    
    /** 删除参数 */
    removeParam(index) {
      this.form.openParam.splice(index, 1);
    },
    
    /** 提交表单 */
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        
        this.submitLoading = true;
        try {
          const submitData = { ...this.form };
          
          // 将openParam数组转换为JSON字符串
          if (Array.isArray(submitData.openParam)) {
            const paramObj = {};
            submitData.openParam.forEach(param => {
              if (param.key && param.value) {
                paramObj[param.key] = param.value;
              }
            });
            submitData.openParam = Object.keys(paramObj).length > 0 ? JSON.stringify(paramObj) : '';
          }
          
          if (this.operationType === 'add') {
            await addAppJump(submitData);
            Message.success("新增成功");
          } else if (this.operationType === 'edit') {
            submitData.id = this.editId;
            await updateAppJump(submitData);
            Message.success("编辑成功");
          } else if (this.operationType === 'copy') {
            await addAppJump(submitData);
            Message.success("复制成功");
          }
          
          this.dialogVisible = false;
          this.$emit("reload");
        } catch (error) {
          Message.error("操作失败");
        } finally {
          this.submitLoading = false;
        }
      });
    },
    
    /** 关闭弹窗 */
    handleClose() {
      this.resetForm();
    }
  }
};
</script>

<style lang="scss" scoped>
.params-container {
  .params-list {
    margin-top: 15px;
    
    .param-item {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style> 